import React, {useRef, useState, useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styled from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { resetToken } from "../actions/recaptchaActions";

import { SITE_KEY } from "../constants/Api";

const Spacer = styled.div`
  padding-bottom: 10px;
`;

const ProtectedSubmit = ({ renderButton, tokenUsed, resetToken }) => {
  const recaptchaInstance = useRef();
  const [verificationToken, setToken] = useState(null);

  useEffect(() => {
    if (tokenUsed && verificationToken !== null) {
      setToken(null);
      resetToken();
    }
  }, [tokenUsed, verificationToken, resetToken]);

  const captchaVerified = token => {
    setToken(token);
  };

  if (verificationToken) {
    return renderButton({
      token: verificationToken
    });
  }

  return (
    <Spacer>
      <ReCAPTCHA
        ref={recaptchaInstance}
        sitekey={SITE_KEY}
        onChange={captchaVerified}
        size="normal"
      />
    </Spacer>
  );
};

ProtectedSubmit.propTypes = {
  renderButton: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  tokenUsed: state.recaptcha.tokenUsed
});

const mapDispatchToProps = dispatch => ({
  resetToken: () => dispatch(resetToken())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedSubmit);
